import QuotedText from './QuotedText';
import { TextAnswerValueProps } from './interfaces';

export const TextAnswerValue = ({ answer }: TextAnswerValueProps) => {
  return <QuotedText>{answer.value}</QuotedText>;
};

export default TextAnswerValue;